import { createIcon } from "@chakra-ui/react";

export const ChevronDown = createIcon({
  displayName: "ChevronDown",
  viewBox: "0 0 24 24",
  d: "M11.396 15.203a1.135 1.135 0 0 0 1.548 0l6.564-6.25a1.009 1.009 0 0 0 0-1.476 1.135 1.135 0 0 0-1.549 0l-5.79 5.515-5.791-5.511a1.135 1.135 0 0 0-1.549 0 1.009 1.009 0 0 0 0 1.474l6.564 6.251.003-.003z",
  defaultProps: {
    "aria-label": "A chevron pointing down"
  }
});

export default ChevronDown;
